module.exports = __webpack_public_path__ + "static/media/icon-cancelar.78b672ab.svg";